import { render, staticRenderFns } from "./alloc_package.vue?vue&type=template&id=15c39716&scoped=true&"
import script from "./alloc_package.vue?vue&type=script&lang=js&"
export * from "./alloc_package.vue?vue&type=script&lang=js&"
import style0 from "./alloc_package.vue?vue&type=style&index=0&id=15c39716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c39716",
  null
  
)

export default component.exports